import * as React from "react";
const SvgReload = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", height: "1em", fill: "none", viewBox: "0 0 16 16", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { stroke: "currentColor", strokeLinecap: "square", d: "M4.75 9.25h-3.5v3.5m10-6h3.5v-3.5" }), /* @__PURE__ */ React.createElement("path", { stroke: "currentColor", d: "M14.104 6.655a6.25 6.25 0 0 0-12.175-.142m-.033 2.832a6.25 6.25 0 0 0 12.174.142" }));
export {
  SvgReload as default
};
//# sourceMappingURL=reload.js.map
